const DeviceQuery = {
  mobile: `max-width: 576px`,
  landscapeMobile: `max-height: 576px`,
  tablet: `max-width: 820px`,
};

export default DeviceQuery;
